export const customerStyles = {
  wrapper: {
    display: "flex",
    flexDirection: "column",
  },
  top: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginBottom: "16px",
  },
  middle: {
    display: "flex",
    alignItems: "center",
    marginBottom: "18px",
  },
  middleImg: {
    marginRight: "22px",
  },
  middlePercDetails: {
    fontWeight: 400,
    fontSize: "15px",
    lineHeight: "24px",
    color: "#103B66",
  },
  bottom: {
    display: "flex",
    color: "#21B8F9",
  },
};
